export const environment = {
  production: true,
  envName: 'DEV',
  apiEndpoint: 'https://cotfertilizantes-api-dev-a3ekccgeawgmdef2.centralus-01.azurewebsites.net/api/',
  azureAd: {
    authority: 'https://login.microsoftonline.com/e365ef77-5132-4232-8ab9-c97057b68043',
    clientId: 'df5ce0c6-9e99-4072-bb2d-aa3f39b4b7fa',
    redirectUri: '/',
    postLogoutRedirectUri: 'https://entregasgranel.dev.glubatec.com/#/login',
    graphEndpoint: 'https://graph.microsoft.com/v1.0/me'
  },
};
